import { combineReducers } from "redux";
import auth from './auth';
import users from './users';
import teams from './teams';

export default combineReducers({ auth, teams, users });
